import { Icon } from '@sunwebgroup/uds-ui/icon'
import { cn } from '@sunwebgroup/uds-ui/utils'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useUser } from '@/domain/user/hooks'
import { CheckoutPreviousStepHeader } from '@/scopes/checkout/components/CheckoutPreviousStepHeader'
import { HeaderContainer, TopNavigationBarItem } from '@/scopes/common/components/Header'
import UserAvatar from '@/scopes/common/components/Header/UserAvatar'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useLocation } from '@/scopes/common/infrastructure/dom/location'
import styles from './CheckoutHeader.module.css'

interface CheckoutHeaderProps {
  showLoginMenu?: boolean
  showBackButton?: boolean
  children?: React.ReactNode
}

export function CheckoutHeader({ showLoginMenu = true, showBackButton = true, children }: CheckoutHeaderProps) {
  const intl = useIntl()
  const { isLoggedIn, logout } = useUser()
  const loginLink = useConfiguration('links.login')
  const location = useLocation()
  const [currentRelativeUrl, setCurrentRelativeUrl] = React.useState('')

  React.useEffect(() => {
    setCurrentRelativeUrl(location.pathQueryFragment())
  }, [location])

  return (
    <HeaderContainer backgroundColor="transparent">
      <div className={cn(styles.content, showLoginMenu && styles.contentWithLoginMenu)}>
        {showLoginMenu
        && (isLoggedIn
          ? (
              <TopNavigationBarItem className={styles.accountButton} onClick={() => logout && logout()}>
                <UserAvatar />
                {intl.formatMessage({ id: 'header_dropdown_menu_logout' })}
              </TopNavigationBarItem>
            )
          : (
              <TopNavigationBarItem
                className={styles.accountButton}
                as="a"
                href={`${loginLink}?returnurl=${encodeURIComponent(currentRelativeUrl)}`}
              >
                <Icon glyph="PersonInCircle" />
                {intl.formatMessage({ id: 'header_dropdown_menu_login' })}
              </TopNavigationBarItem>
            ))}
        <div className={styles.backButtonSlot} translate="no">
          {showBackButton && <CheckoutPreviousStepHeader />}
        </div>
        {children && <>{children}</>}
      </div>
    </HeaderContainer>
  )
}
